import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMagnifyingGlass = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 21,
	height: 20,
	viewBox: "0 0 21 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M9.31543 15C12.7672 15 15.5654 12.2018 15.5654 8.75C15.5654 5.29822 12.7672 2.5 9.31543 2.5C5.86365 2.5 3.06543 5.29822 3.06543 8.75C3.06543 12.2018 5.86365 15 9.31543 15Z",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.7354 13.1699L18.0658 17.5004",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgMagnifyingGlass;
